import { Button, Popover, Box } from '@mui/material';
import NumberFormat from 'react-number-format';
import { UseTableCellProps } from 'react-table';
import { useMenu } from 'shared/hooks';
import { Product } from 'shared/types';

export default function RecommendedPriceColumn(props: UseTableCellProps<Product>) {
    const [anchorEl, handleOpen, handleClose, open] = useMenu();
    const {
        row: { original },
    } = props;
    return (
        <Box height='100%' display='flex' justifyContent='center' alignItems='center'>
            <Button onClick={handleOpen} color='secondary'>
                <NumberFormat
                    value={original.recommendedPrice}
                    displayType='text'
                    thousandSeparator={true}
                    prefix='$'
                />
            </Button>
            <Popover
                id='mouse-over-popover'
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClose={handleClose}
            >
                <Box padding={1}>{original.recommendedPriceMath || 'Not Sold in DTC'}</Box>
            </Popover>
        </Box>
    );
}
